import { render, staticRenderFns } from "./chatbot-btn.vue?vue&type=template&id=2624a611&"
import script from "./chatbot-btn.vue?vue&type=script&lang=js&"
export * from "./chatbot-btn.vue?vue&type=script&lang=js&"
import style0 from "./chatbot-btn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports